module.exports = "<p class=\"text-red mt-2\">\n  <b>{{ message }}</b>\n</p>\n"